import { Component, OnInit } from '@angular/core';
import { CallBackEndService } from '../call-back-end.service';
import { IbRequest } from '../ib-request';
import { IbResponse } from '../ib-response';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as $ from 'jquery';
declare var getHexAscii: any;

@Component({
  selector: 'app-modify-or-delete-payee',
  templateUrl: './modify-or-delete-payee.component.html',
  styleUrls: ['./modify-or-delete-payee.component.css']
})
export class ModifyOrDeletePayeeComponent implements OnInit {

   public filterQuery = '';
  public rowsOnPage = 5;
  public sortBy = 'particulars';
  public sortOrder = 'asc';
	nickName: string;
  isShow: string = 'page1';
  payeeType: any="";
  isLoad: boolean = false;
  payeeList: any;
  data:any;
  payeeDetail: any;
  getAllPayeeResp: IbResponse;
  otp: any;
  error: string = '';

  reg = /[-!$%^&*()_+|~=`{}[:;<>?,.@#\]]/g;
  regNum = /^[0-9]+$/;
  regchar = '/^[a-zA-Z]+$/';
  regexpspace = /\s+/;
  regZeroOnly = '^[0][0]*[0]$';
  regNumbers = /^.*[0-9]/;
invalidIFSC:string;
  fullnameblankModify: string;
  alltrueModify: string='true';
  fullnameSpeciModify: string;
  fullnamelengthModify: string;
  fullnameNumbersModify: string;
  fullnameSpaceModify: string;
  payeeIfscNotlankModify: string;
  payeeIfscmessageForSpaceModify: string;
  payeeIfscmessageForacctspeciModify: string;
  payeeIfscmessageForacctLengthModify: string;
  payeeIfscmessageForacctMinLengthModify: string;
  payeeCheckZeroOnlyModify: string;
  ifscCodeblankModify: string;
  ifscCodeNoSpaceModify: string;
  ifscCodenotnospecialModify: string;
  ifscCodenotlengthModify: string;
  ifscCodeOnlyZeroesModify: string;
  ifscCheckZeroOnlyModify: string;
  IfscMobtNoblankModify: string;
  IfscMobNoSpaceModify: string;
  IfscnotMobNumberModify: string;
  IfscnotMobspecialModify: string;
  IfscnotRangeModify: string;
  payeesucess:string;
   IfscErr:string;
  MobileZeroOnlyModify: string;
  mmidNoblankModify: string;
  mmidNoSpaceModify: string;
  mmidNumberModify: string;
  mmidspecialModify: string;
  mmidnotRangeModify: string;
  mmidZeroOnlyModify: string;
  aadharNoSpaceModify: string;
  aadharNumberModify: string;
  aadharspecialModify: string;
  aadharnotRangeModify: string;
  aadharnotZeroOnlyModify: string;
  aadharNoblankModify: string;
  alltrue: string;
  disabled: boolean;
  disabledaddpayeenext: boolean;
  ifsccd: string;
  mmid: string;
  payeeIfscmessageForSpace: string;
  OtpNotlank: string;
   dataTable: any;


  constructor(private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    }

  getAllPayeeRequest() {
    this.error = '';
    if (this.payeeType) {
      this.spinnerService.show();
      this.isLoad = true;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName') + this.payeeType);
      request.param2 =sessionStorage.getItem('storedUserName');
      request.param3 = this.payeeType;
      this.webService.getResponse(request, 'getAllPayee').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
		this.getAllPayeeResp = response;
		   const table: any = $('table');
    //this.dataTable = table.DataTable();
        this.isLoad = false;
        if (response !== null) {
		  this.payeeList = response.param6;
		  this.data= response.param6;
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  deletePayeeRequest(nickName) {
    this.error = '';
    if (nickName) {
      this.spinnerService.show();
      this.isLoad = true;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      if (confirm('Do You Want Delete Payee :' + nickName) === true) {
        request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName') + nickName);
        request.param2 =sessionStorage.getItem('storedUserName');
        request.param3 = nickName;
        this.webService.getResponse(request, 'deletePayee').subscribe((data: IbResponse) => {
          this.spinnerService.hide();
          response = data;
          this.isLoad = false;
          if (response !== null) {
            this.getAllPayeeRequest();
            alert(response.param1);
          } else if (response !== null) {
            this.error = response.param1;
          } else {
            this.error = 'Something Went Wrong Please Contact Customer Care';
          }
        });
      }else{
        this.spinnerService.hide();
      }
    }
  }

  getPayeeRequest(nickName) {
    this.error = '';
    if (nickName) {
      this.spinnerService.show();
      this.isLoad = true;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName') + nickName);
      request.param2 =sessionStorage.getItem('storedUserName');
      request.param3 = nickName;
      this.webService.getResponse(request, 'getPayee').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        if (response !== null) {
          this.payeeDetail = response.param5;
          this.isShow = 'page2';
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  getOtp() {
    this.error = '';
    if (this.payeeDetail.fullname === undefined || this.payeeDetail.fullname === '') {

      this.fullnameblankModify = 'no';
      this.alltrueModify = 'false';
    } else if ((this.payeeDetail.ifsccd !== undefined && this.payeeDetail.ifsccd !== '') && (this.payeeDetail.acctno === undefined || this.payeeDetail.acctno === '')) {
      this.payeeIfscNotlankModify = 'no';
      this.alltrueModify = 'false';
    } else if ((this.payeeDetail.mmid !== undefined && this.payeeDetail.mmid !== '') && (this.payeeDetail.mobileNo === undefined || this.payeeDetail.mobileNo === '')) {
      this.IfscMobtNoblankModify = 'no';
      this.alltrueModify = 'false';
    } else if ((this.payeeDetail.acctno === undefined || this.payeeDetail.acctno === '') && (this.payeeDetail.mobileNo === undefined || this.payeeDetail.mobileNo === '')) {
      this.alltrueModify = 'false';
      alert('Please Enter Account Number and IFSC Code Or Mobile Number And MMID Or Aadhar Number');
    } else if ((this.payeeDetail.acctno !== undefined || this.payeeDetail.acctno !== '') && (this.payeeDetail.mobileNo === undefined || this.payeeDetail.mobileNo === '')) {
      if (this.payeeDetail.acctno.match(this.regexpspace)) {
        this.payeeIfscmessageForSpaceModify = 'no';
        //this.disabledaddpayeenext=true;
        this.alltrueModify = 'false';

      } else if (this.payeeDetail.acctno.match(this.reg)) {
        this.payeeIfscmessageForacctspeciModify = 'no';
        //this.disabledaddpayeenext=true;
        this.alltrueModify = 'false';
      } else if (this.payeeDetail.acctno.length > 18) {
        this.payeeIfscmessageForacctLengthModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.acctno.length < 9) {
        this.payeeIfscmessageForacctMinLengthModify = 'no';
        this.alltrueModify = 'false';
        //  this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.acctno.match(this.regZeroOnly)) {
        this.payeeCheckZeroOnlyModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.ifsccd === undefined || this.ifsccd === '') {
        this.ifscCodeblankModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.ifsccd === ' ' || this.payeeDetail.ifsccd.indexOf(' ') !== -1) {
        this.ifscCodeNoSpaceModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.ifsccd.match(this.reg)) {
        this.ifscCodenotnospecialModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.ifsccd.length > 11) {
        this.ifscCodenotlengthModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.ifsccd.match(this.regZeroOnly)) {
        this.ifscCheckZeroOnlyModify = 'no';
        this.alltrueModify = 'false';
        //  this.disabledaddpayeenext=true;

      }
    } else if ((this.payeeDetail.acctno === undefined || this.payeeDetail.acctno === '') && (this.payeeDetail.mobileNo !== undefined || this.payeeDetail.mobileNo !== '')) {

      if (this.payeeDetail.mobileNo === ' ' || this.payeeDetail.mobileNo.indexOf(' ') !== -1) {
        this.IfscMobNoSpaceModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (!this.payeeDetail.mobileNo.match(this.regNum)) {
        this.IfscnotMobNumberModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mobileNo.match(this.reg)) {
        this.IfscnotMobspecialModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mobileNo.trim().length !== 10) {
        this.IfscnotRangeModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mobileNo.match(this.regZeroOnly)) {
        this.MobileZeroOnlyModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mmid === undefined || this.mmid === '') {
        this.mmidNoblankModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mmid === ' ' || this.payeeDetail.mmid.indexOf(' ') !== -1) {
        this.mmidNoSpaceModify = 'no';
        this.alltrueModify = 'false';
        this.disabledaddpayeenext = true;
      } else if (!this.payeeDetail.mmid.match(this.regNum)) {
        this.mmidNumberModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (!this.payeeDetail.mmid.match(this.regNum)) {
        this.mmidNumberModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mmid.match(this.regZeroOnly)) {
        this.mmidZeroOnlyModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mmid.trim().length !== 7) {
        this.mmidnotRangeModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      }
    } else if ((this.payeeDetail.acctno !== undefined || this.payeeDetail.acctno !== '') && (this.payeeDetail.mobileNo !== undefined || this.payeeDetail.mobileNo !== '')) {
      if (this.payeeDetail.acctno.match(this.regexpspace)) {
        this.payeeIfscmessageForSpace = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;

      } else if (this.payeeDetail.acctno.match(this.reg)) {
        this.payeeIfscmessageForacctspeciModify = 'no';
        this.alltrueModify = 'false';

        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.acctno.length > 18) {
        this.payeeIfscmessageForacctLengthModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.acctno.length < 9) {
        this.payeeIfscmessageForacctMinLengthModify = 'no';
        this.alltrueModify = 'false';
        //  this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.acctno.match(this.regZeroOnly)) {
        this.payeeCheckZeroOnlyModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.ifsccd === undefined || this.payeeDetail.ifsccd === '') {
        this.ifscCodeblankModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.ifsccd === ' ' || this.payeeDetail.ifsccd.indexOf(' ') !== -1) {
        this.ifscCodeNoSpaceModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.ifsccd.match(this.reg)) {
        this.ifscCodenotnospecialModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.ifsccd.length > 11) {
        this.ifscCodenotlengthModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.ifsccd.match(this.regZeroOnly)) {
        this.ifscCheckZeroOnlyModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mobileNo === ' ' || this.payeeDetail.mobileNo.indexOf(' ') !== -1) {
        this.IfscMobNoSpaceModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (!this.payeeDetail.mobileNo.match(this.regNum)) {
        this.IfscnotMobNumberModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mobileNo.match(this.reg)) {
        this.IfscnotMobspecialModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mobileNo.trim().length !== 10) {
        this.IfscnotRangeModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mobileNo.match(this.regZeroOnly)) {
        this.MobileZeroOnlyModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      }
      //MMID
      if (this.payeeDetail.mmid === undefined || this.payeeDetail.mmid === '') {
        this.mmidNoblankModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mmid === ' ' || this.payeeDetail.mmid.indexOf(' ') !== -1) {
        this.mmidNoSpaceModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (!this.payeeDetail.mmid.match(this.regNum)) {
        this.mmidNumberModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mmid.match(this.reg)) {
        this.mmidspecialModify = 'no';
        this.alltrueModify = 'false';
        //this.payeeDetail.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mmid.trim().length !== 7) {
        this.mmidnotRangeModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      } else if (this.payeeDetail.mmid.match(this.regZeroOnly)) {
        this.mmidZeroOnlyModify = 'no';
        this.alltrueModify = 'false';
        //this.disabledaddpayeenext=true;
      }
    }
    if (this.payeeDetail.nickname && this.payeeDetail.fullname && ((this.payeeDetail.acctno && this.payeeDetail.ifsccd) || (this.payeeDetail.mmid && this.payeeDetail.mobileNo) || (this.payeeDetail.aadharNo)) && this.alltrueModify === 'true') {
      this.isLoad = true;

      this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName'));
      request.param2 =sessionStorage.getItem('storedUserName');
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        this.isLoad = false;
        response = data;
        if (response !== null) {
          // console.log('Otp :' + response.param1);
          this.isShow = 'page3';
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }

  modifyPayeeRequest(nickName) {
    if(this.getpayeeOTPValid()){
    this.error = '';
    if (nickName && this.payeeDetail.fullname && ((this.payeeDetail.acctno && this.payeeDetail.ifsccd) || (this.payeeDetail.mmid && this.payeeDetail.mobileNo) ) ) {
      this.isLoad = true;
      let accountNo: string = '';
      let ifscCode: string = '';
      let mobileNo: string = '';
      let mmid: string = '';
      let aadharNo: string = '';
      if (this.payeeDetail.mobileNo){
        mobileNo = this.payeeDetail.mobileNo;
      }
      if (this.payeeDetail.mmid){
        mmid = this.payeeDetail.mmid;
      }
      if (this.payeeDetail.acctno){
        accountNo = this.payeeDetail.acctno;
      }
      if (this.payeeDetail.ifsccd){
        ifscCode = this.payeeDetail.ifsccd;
      }
      if (this.payeeDetail.aadharNo){
        aadharNo = this.payeeDetail.aadharNo;
      }

      const payeeInfo = {
        'userName':sessionStorage.getItem('storedUserName'),
        'nickName': nickName,
        'fullName': this.payeeDetail.fullname,
        'acctNo': accountNo,
        'ifscCd': ifscCode,
        'mobileNo': mobileNo,
        'mmid': mmid,
        'aadharNo': aadharNo,
        'addOrModify': 'U'
      };
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.spinnerService.show();
      request.param1 = getHexAscii('', this.otp +sessionStorage.getItem('storedUserName') + nickName + this.payeeDetail.fullname + accountNo + ifscCode + mobileNo + mmid + aadharNo + 'U');
      request.param2 = getHexAscii('',this.otp);
      request.param6 = payeeInfo;
      this.webService.getResponse(request, 'addOrModifyPayee').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        this.isLoad = false;
        response = data;
        if (response !== null&&response.status==='S200') {
         // alert(response.param1);
          this.isShow = 'page4';
          this.payeesucess=response.param1;
          this.getAllPayeeRequest();
        } else if (response !== null) {
          this.error = response.param1;
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }
}

  getpayeeOTPValid_old() {
    if (this.otp === undefined || this.otp === '') {
      this.OtpNotlank = 'no';
      this.disabledaddpayeenext = true;
    }
  }

  getpayeeOTPValid() {
    if (this.otp === undefined || this.otp === '') {
      this.OtpNotlank = 'no';
      this.disabledaddpayeenext = true;
      return false;
    }else if (this.otp.match(this.reg)) {
      this.OtpNotlank = 'specialChar';
      this.disabledaddpayeenext = true;
      return false;
    }else if (!this.otp.match(this.regNum)) {
      this.OtpNotlank = 'num';
      this.disabledaddpayeenext = true;
      return false;
    } else if (this.otp.length!=6) {
      this.OtpNotlank = 'len';
      this.disabledaddpayeenext = true;
      return false;
    }else{
      this.OtpNotlank = '';
      this.disabledaddpayeenext = false;
      return true;
    }
  }
  changeGetpayeeOTPValid(){
    this.OtpNotlank = '';
    this.error='';
      this.disabledaddpayeenext = false;
  }

  back1() {
    this.isShow = 'page1';
    this.disabled = false;
    this.otp = '';
    this.removeAdharMessageModify();
    this.removeFullNameMessageModify();
    this.removeIfscmobileMessageModify();
    this.removeMMIDMessageModify();
    this.removePayeeAcctMessageModify();
    this.getIfscRemoveModify();
  }

  back2() {
    this.isShow = 'page2';
    this.disabled = false;
    this.otp = '';
  }

  validateFullNameModify() {
    if (this.payeeDetail.fullname === undefined) {
      this.fullnameblankModify = 'no';
      this.alltrueModify = 'false';
    } else if (this.payeeDetail.fullname === '' || this.payeeDetail.fullname === undefined) {
      this.fullnameblankModify = 'no';
      this.alltrueModify = 'false';
    } else if (this.payeeDetail.fullname.match(this.reg)) {
      this.fullnameSpeciModify = 'no';
      this.alltrueModify = 'false';
    } else if (this.payeeDetail.fullname.length > 50) {
      this.fullnamelengthModify = 'no';
      this.alltrueModify = 'false';
    } else if (this.payeeDetail.fullname.match(this.regNumbers)) {
      this.fullnameNumbersModify = 'no';
      this.alltrueModify = 'false';
    }

  }

  removeFullNameMessageModify() {
    this.fullnameSpaceModify = '';
    this.fullnameblankModify = '';
    this.fullnameSpeciModify = '';
    this.fullnamelengthModify = '';
    this.fullnameNumbersModify = '';

    this.alltrueModify = 'true';
  }

  removePayeeAcctMessageModify() {
    this.payeeIfscNotlankModify = '';
    this.payeeIfscmessageForSpaceModify = '';
    this.payeeIfscmessageForacctspeciModify = '';
    this.payeeIfscmessageForacctLengthModify = '';
    this.payeeIfscmessageForacctMinLengthModify = '';
    this.payeeCheckZeroOnlyModify = '';
    this.disabledaddpayeenext = false;
    this.alltrueModify = 'true';
  }

  getIfscRemoveModify() {
    this.ifscCodeblankModify = '';
    this.ifscCodeNoSpaceModify = '';
    this.ifscCodenotnospecialModify = '';
    this.ifscCodenotlengthModify = '';
    this.ifscCodeOnlyZeroesModify = '';
    this.ifscCheckZeroOnlyModify = '';
    this.invalidIFSC='';
    this.alltrueModify = 'true';
  }

  removeIfscmobileMessageModify() {
    this.IfscMobtNoblankModify = '';
    this.IfscMobNoSpaceModify = '';
    this.IfscnotMobNumberModify = '';
    this.IfscnotMobspecialModify = '';
    this.IfscnotRangeModify = '';
    this.MobileZeroOnlyModify = '';
    this.alltrueModify = 'true';

  }
  removeMMIDMessageModify() {
    this.mmidNoblankModify = '';
    this.mmidNoSpaceModify = '';
    this.mmidNumberModify = '';
    this.mmidspecialModify = '';
    this.mmidnotRangeModify = '';
    this.mmidZeroOnlyModify = '';
    this.alltrue = 'true';
  }

  validateAdharAndAcctMobModify() {

    if (this.payeeDetail.aadharNo !== undefined && this.payeeDetail.aadharNo !== '' && this.payeeDetail.aadharNo !== '') {

      if (this.payeeDetail.aadharNo === ' ' || this.payeeDetail.aadharNo.indexOf(' ') !== -1) {
        this.aadharNoSpaceModify = 'no';
      } else if (!this.payeeDetail.aadharNo.match(this.regNum)) {
        this.aadharNumberModify = 'no';
        this.disabled = true;
      } else if (this.payeeDetail.aadharNo.match(this.reg)) {
        this.aadharspecialModify = 'no';
        this.disabled = true;
      } else if (this.payeeDetail.aadharNo.trim().length !== 12) {
        this.aadharnotRangeModify = 'no';
        this.disabled = true;
      } else if (this.payeeDetail.aadharNo.match(this.regZeroOnly)) {
        this.aadharnotZeroOnlyModify = 'no';
        this.disabled = true;
      }
    }
  }

  removeAdharMessageModify() {

    this.aadharNoblankModify = '';
    this.aadharNoSpaceModify = '';
    this.aadharNumberModify = '';
    this.aadharspecialModify = '';
    this.aadharnotRangeModify = '';
    this.aadharnotZeroOnlyModify = '';
    this.alltrueModify = 'true';
    this.disabled = false;
  }
 validateIfscCode() {
    this.error = '';
    if (this.payeeDetail.ifsccd === undefined || this.payeeDetail.ifsccd === '') {
      this.ifscCodeblankModify = 'no';
      this.disabled = true;
    } else if (this.payeeDetail.ifsccd === ' ' || this.payeeDetail.ifsccd.indexOf(' ') !== -1||this.payeeDetail.ifsccd.match(this.regexpspace)) {
      this.ifscCodeNoSpaceModify = 'no';
      this.disabled = true;
    } else if (this.payeeDetail.ifsccd.match(this.reg)) {
      this.ifscCodenotnospecialModify = 'no';
      this.disabled = true;
    } else if (this.payeeDetail.ifsccd.length > 11||this.payeeDetail.ifsccd.length < 11) {
      this.ifscCodenotlengthModify = 'no';
      this.disabled = true;
    } else if (this.payeeDetail.ifsccd.match(this.regZeroOnly)) {
      this.ifscCheckZeroOnlyModify = 'no';
      this.disabled = true;
    } else if (this.payeeDetail.ifsccd) {
       this.spinnerService.show();
      this.disabled = false;
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      this.isLoad = true;
      request.param1 = getHexAscii('', this.payeeDetail.ifsccd);
      request.param2 = this.payeeDetail.ifsccd;
     
      this.webService.getResponse(request, 'isValidIfscCode').subscribe((data: IbResponse) => {
        this.spinnerService.hide();
        response = data;
        this.isLoad = false;
        if (response !== null && response.status === 'OBJECT_NOT_FOUND') {
         this.invalidIFSC='no';
         this.IfscErr=response.param1;
          this.disabled = true;
          this.payeeDetail.ifsccd = '';
        } else if (response !== null) {
          if (response.status !== 'S200') {
            this.error = response.statusDescription;
          }
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }


}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/modify-or-delete-payee/modify-or-delete-payee.component.ts